module.exports = __webpack_public_path__ + "static/img/xiugaiyinliang.6566768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/xiugaiyinliang.png
// module id = +yOn
// module chunks = 24